import React, { useState } from "react";
import { DatePicker, Select, Button } from "antd";
import { useTranslation } from "react-i18next";

const { RangePicker } = DatePicker;
const { Option } = Select;

const CampaignsFilters = ({ clientOptions = [], onApply }) => {
  const { t } = useTranslation();
  const [range, setRange] = useState([]);
  const [clientId, setClientId] = useState(undefined);

  const handleApply = () => {
    const from = range && range[0];
    const to = range && range[1];
    onApply({
      dateFrom: from ? from.format("YYYY-MM-DD") : null,
      dateTo: to ? to.format("YYYY-MM-DD") : null,
      clientId: clientId || null,
    });
  };

  return (
    <div className="campaignsManager__filters">
      <div className="campaignsManager__filters-field">
        <label>{t("Dates")}:</label>
        <RangePicker value={range} onChange={setRange} format="DD/MM/YYYY" />
      </div>

      <div className="campaignsManager__filters-field campaignsManager__filters-client">
        <label>{t("Client")}:</label>
        <Select
          showSearch
          allowClear
          placeholder={t("Select client")}
          value={clientId}
          onChange={setClientId}
          optionFilterProp="children"
          style={{ width: "100%" }}
        >
          {clientOptions.map((c) => (
            <Option key={c.id} value={c.id}>
              {c.name}
            </Option>
          ))}
        </Select>
      </div>

      <Button type="primary" onClick={handleApply}>
        {t("Apply")}
      </Button>
    </div>
  );
};

export default CampaignsFilters;
